<template>
    <div class="tw-px-4">
        <div class="tw-grid tw-grid-cols-12 tw-gap-4">
            <div class="lg:tw-col-span-3 tw-col-span-12">
                <div class="tw-h-[250px]x tw-pb-8 tw-p-4 tw-bg-white tw-border tw-border-solid tw-border-primary-200 tw-rounded-lg">
                    <div class="tw-flex tw-justify-end">
                        <button class="tw-text-gray-500 tw-text-sm tw-font-semibold">Edit</button>
                    </div>

                    <div class="tw-flex tw-items-center tw-justify-center tw-mt-4 tw-flex-col">
                        <div class="tw-w-[100px] tw-h-[100px] tw-rounded-full tw-bg-primary-800 tw-flex tw-items-center tw-justify-center tw-relative">
                            <icon icon="solar:user-circle-linear" class="tw-text-primary-50 tw-text-6xl tw-font-semibold " />

                            <div class="tw-absolute tw-bottom-1 tw-right-1 tw-w-[20px] tw-h-[20px] tw-rounded-full tw-bg-primary-500 tw-flex tw-items-center tw-justify-center tw-border-4 tw-border-solid tw-border-white"></div>
                        </div>

                        <h1 class="tw-text-primary-950 tw-text-lg md:tw-text-2xl tw-font-semibold tw-mt-2 tw-text-center">{{ $user.name }}</h1>
                        <h2 class="tw-text-primary-950 tw-text-sm tw-font-semibold tw-mt-1 tw-text-center">CEO, Date Company</h2>
                    </div>


                    
                </div>

                <div class="tw-mt-4">
                    <h1 class="tw-text-primary-950 tw-text-xl tw-font-semibold">My Companies</h1>
                </div>

                <div class="tw-h-[80px]x tw-bg-white tw-border tw-border-solid tw-border-primary-200 tw-rounded-lg tw-mt-4 tw-flex tw-gap-4 tw-p-4">
                    <div>
                        <icon icon="streamline-kameleon-color:apartment-2-duo" class="tw-text-6xl" />
                    </div>

                    <div class="tw-flex tw-flex-col tw-justify-center tw-gap-1">
                        <h1 class="tw-text-primary-950 tw-text-xl tw-font-semibold">Date Company</h1>
                        <h2 class="tw-text-primary-950 tw-text-sm tw-font-semibold tw-capitalize">{{ $user.role }}</h2>
                    </div>

                    <div class="tw-flex-1"></div>

                    <div class="tw-flex tw-items-center tw-justify-center">
                        <button class="">
                            <icon icon="solar:pen-linear" class="tw-text-gray-400 tw-text-2xl" />
                        </button>
                    </div>
                </div>

                <div class="tw-h-[80px]x tw-bg-white tw-border tw-border-solid tw-border-primary-200 tw-rounded-lg tw-mt-4 tw-flex tw-gap-4 tw-p-4">
                    <div>
                        <icon icon="streamline-kameleon-color:farm" class="tw-text-6xl" />
                    </div>

                    <div class="tw-flex tw-flex-col tw-justify-center tw-gap-1">
                        <h1 class="tw-text-primary-950 tw-text-xl tw-font-semibold">Green Export</h1>
                        <h2 class="tw-text-primary-950 tw-text-sm tw-font-semibold tw-capitalize">{{ $user.role }}</h2>
                    </div>

                    <div class="tw-flex-1"></div>

                    <div class="tw-flex tw-items-center tw-justify-center">
                        <button class="">
                            <icon icon="solar:pen-linear" class="tw-text-gray-400 tw-text-2xl" />
                        </button>
                    </div>
                </div>
                
            </div>

            <div class="lg:tw-col-span-6 tw-col-span-12">
                <div class="tw-h-[200px] tw-rounded-lg tw-bg-primary-800"></div>

                <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-mt-4">
                    <div class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-200 tw-flex tw-items-center tw-justify-center">
                        <p class="tw-text-primary-950 tw-text-lg md:tw-text-2xl tw-font-semibold ">My Eshow</p>
                    </div>
                    <div class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-200 tw-flex tw-items-center tw-justify-center">
                        <p class="tw-text-primary-950 tw-text-lg md:tw-text-2xl tw-font-semibold ">Exhibitors</p>
                    </div>

                    <div class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-500 tw-flex tw-items-center tw-justify-center">
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold ">VIB - Buyers</p>
                    </div>
                    <div class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-500 tw-flex tw-items-center tw-justify-center">
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold ">Community</p>
                    </div>

                    <div class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-500 tw-flex tw-items-center tw-justify-center">
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold ">Speakers</p>
                    </div>
                    <div class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-500 tw-flex tw-items-center tw-justify-center">
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold ">Agenda</p>
                    </div>

                    <div class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-900 tw-flex tw-items-center tw-justify-center">
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold ">Products</p>
                    </div>
                    <div class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-primary-900 tw-flex tw-items-center tw-justify-center">
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold ">Services</p>
                    </div>

                    <div class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-orange-200 tw-flex tw-items-center tw-justify-center tw-gap-2">
                        <icon icon="solar:clapperboard-play-linear" class="tw-text-primary-800 tw-text-3xl tw-font-semibold " />
                        <p class="tw-text-primary-800 tw-text-lg md:tw-text-2xl tw-font-semibold ">VOD</p>
                    </div>
                    <div class="md:tw-h-[100px] tw-h-[80px] tw-rounded-lg tw-bg-sky-600 tw-flex tw-items-center tw-justify-center tw-gap-2">
                        <icon icon="solar:help-linear" class="tw-text-primary-50 tw-text-3xl tw-font-semibold " />
                        <p class="tw-text-primary-50 tw-text-lg md:tw-text-2xl tw-font-semibold ">Help Desk</p>
                    </div>
                </div>

            </div>

            <div class="lg:tw-col-span-3 tw-col-span-12 tw-h-[600px] tw-bg-primary-600 tw-rounded-lg tw-border tw-border-solid tw-border-primary-200">

            </div>

        </div>

        <div class="tw-mt-6">
            <h1 class="tw-text-primary-950 tw-text-lg md:tw-text-2xl tw-font-semibold tw-text-center">Sponsors</h1>
        </div>

        <div class="tw-flex tw-justify-center tw-items-center tw-gap-12 tw-mt-4 tw-flex-wrap">
            <div>
                <icon icon="streamline-kameleon-color:farm" class="tw-text-7xl" />
            </div>
            <div>
                <icon icon="streamline-kameleon-color:strawberry" class="tw-text-7xl" />
            </div>
            <div>
                <icon icon="streamline-kameleon-color:reindeer" class="tw-text-7xl" />
            </div>
            <div>
                <icon icon="streamline-kameleon-color:wind-wheel" class="tw-text-7xl" />
            </div>
        </div>
    </div>
  </template>
  
  <script setup></script>
  
  <style></style>
  